import React, { useCallback, useEffect, useState } from "react";
import { Button, Image, Modal, Rate } from "antd";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import {
	EmptyData,
	InviteSection,
	PageLoading,
	SplitPane,
} from "../../components";
import MainLayout from "../../components/MainLayout/MainLayout";
import { hideScrollbar, LandingTitle } from "../../lib/styles/styleLibrary";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { useMediaQuery } from "react-responsive";
import {
	CardContainer,
	VendorAddress,
	VendorTitle,
	VWrapper,
} from "./component";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { fetchVendorDetails } from "../../redux/actions/vendor";
import pin from "../../assets/svg/map-pin-white.svg";
import { isEmpty } from "../../lib/helpers/helpers";
import { ImageMansoryWrapper } from "../OurPhotos/component";
import Gallery from "react-photo-gallery";
import Carousel, { ModalGateway } from "react-images";

const ImageMansory = ({ vendorAlbum }) => {
	// console.log("the vendor album", vendorAlbum, vendorAlbum?.length);
	const photos = [];
	const [currentImage, setCurrentImage] = useState(0);
	const [viewerIsOpen, setViewerIsOpen] = useState(false);

	useEffect(() => {
		vendorAlbum?.forEach((i) => {
			vendorAlbum?.length === 1
				? photos.push({
						src: i.media_url,
						src_min: i.media_url_min,
						width: 3,
						height: 4,
				  })
				: photos.push({
						src: i.media_url,
						src_min: i.media_url_min,
						// width: Math.floor(Math.random() * 3) + 4,
						// height: Math.floor(Math.random() * 4) + 2,
						width: 5,
						height: 4,
				  });
		});
		// eslint-disable-next-line
	}, [vendorAlbum]);

	const openLightbox = useCallback((event, { photo, index }) => {
		setCurrentImage(index);
		setViewerIsOpen(true);
	}, []);

	const closeLightbox = () => {
		setCurrentImage(0);
		setViewerIsOpen(false);
	};
	return (
		<ImageMansoryWrapper>
			{isEmpty(vendorAlbum) ? (
				<div tw="h-full w-full flex items-center justify-center">
					<EmptyData />
				</div>
			) : (
				<>
					<Gallery photos={photos} onClick={openLightbox} />
					<ModalGateway>
						{viewerIsOpen ? (
							<Modal onClose={closeLightbox}>
								<Carousel
									currentIndex={currentImage}
									views={photos.map((x) => ({
										...x,
										srcset: x.srcSet,
										caption: x.title,
									}))}
								/>
							</Modal>
						) : null}
					</ModalGateway>
				</>
			)}
		</ImageMansoryWrapper>
	);
};

const VendorPortfolio = (props) => {
	// console.log(props.vendorPhotos, "the photos");
	return (
		<div tw="pt-8">
			<CardContainer
				tw="w-full h-60 shadow-md min-w-min"
				background={props.coverImage}>
				<div tw="flex flex-col  flex items-center justify-center p-4 h-full gap-4">
					<VendorTitle>{props.title}</VendorTitle>
					<div>
						<Rate
							allowHalf
							value={props.rating}
							tw="text-appPink text-xs md:text-base inline-flex flex-nowrap mr-4"
						/>
					</div>
					<div
						tw="inline-flex items-center gap-2"
						css={{
							width: "inherit",
						}}>
						<Image
							preview={false}
							src={pin}
							alt=""
							width={15}
							height={20}
						/>
						<span tw="text-xs sm:text-base text-white font-medium truncate">
							{props.location}
						</span>
					</div>
					<VendorAddress>{props.address}</VendorAddress>{" "}
				</div>
			</CardContainer>
			<div tw="mt-8 mb-8">
				<ImageMansory vendorAlbum={props.vendorPhotos} />
			</div>
		</div>
	);
};

const Vendor = (props) => {
	const history = useHistory();
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const [showMore, setShowMore] = useState(false);
	const [vendorData, setVendorData] = useState({});
	const [phone, setPhone] = useState("");
	const { id } = useParams();

	const { data, isLoading } = useQuery(
		["vendorDetails", { id }],
		() => fetchVendorDetails(id),
		{
			refetchOnWindowFocus: false,
		}
	);

	useEffect(() => {
		if (isEmpty(data?.vendor)) {
			return;
		}
		setVendorData(data);
		const pn = data?.vendor?.phone.substr(data?.vendor?.phone.length - 10);
		const phone = !isEmpty(pn) ? pn : "";
		setPhone("234" + phone);
	}, [data]);

	// console.log("vendor details\n", vendorData);
	return (
		<MainLayout>
			<VWrapper>
				<div tw="flex flex-nowrap justify-between gap-2 md:w-full w-3/5">
					<div
						tw="inline-flex flex-nowrap items-center gap-2 hover:cursor-pointer mb-4"
						onClick={() => {
							history.goBack();
						}}>
						<ArrowLeftOutlined tw="px-2 py-2 bg-gray-100 rounded-full hover:bg-white" />
						<LandingTitle tw="text-lg md:text-2xl font-bold leading-8 m-0! whitespace-pre">
							Vendor
						</LandingTitle>
					</div>
					<span>
						<Button type="primary" shape="round" tw=" px-6" danger>
							{vendorData?.vendor?.has_bookmarked
								? "Bookmarked"
								: "Bookmark"}
						</Button>
						<a
							href={`https://api.whatsapp.com/send?phone=${phone}`}
							target="_blank"
							rel="noreferrer">
							<Button
								type="primary"
								shape="round"
								tw="ml-2 px-6"
								danger>
								Chat
							</Button>
						</a>
					</span>
				</div>

				<div
					tw="w-full overflow-y-scroll"
					css={hideScrollbar}
					style={{ height: isMobile ? "80vh" : "auto" }}>
					{isLoading && <PageLoading />}
					<SplitPane
						// hideRightSide={isMobile ? true : false}
						hideRightSide={true}
						wrapDirection={"column"}
						left={
							<VendorPortfolio
								coverImage={
									vendorData?.vendor?.vendor_cover_image
										?.media_url
								}
								title={vendorData?.vendor?.stand_name}
								rating={vendorData?.vendor?.average_rating}
								location={
									vendorData?.vendor?.stand_location_address
								}
								loading={isLoading}
								vendorPhotos={vendorData?.vendor?.vendor_images}
								address={"3.2 KM Away"}
							/>
						}
						// right={<InviteSection />}
					/>
				</div>
				<Modal
					footer=""
					visible={showMore}
					centered
					onCancel={() => setShowMore(false)}
					maskClosable={false}>
					<InviteSection />
				</Modal>
			</VWrapper>
		</MainLayout>
	);
};

export default Vendor;
